import { render, staticRenderFns } from "./TranProgramModuleActivityCreateDetail.vue?vue&type=template&id=436d3c5c"
import script from "./TranProgramModuleActivityCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleActivityCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleActivityCreateDetail.vue?vue&type=style&index=0&id=436d3c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports